import { createContext } from 'react';
import {
	ICreateSubCategoryValidationError,
	IServerError,
	TFileId,
	TLanguageIDs,
	IMenuTranslation,
	IDefaultLanguage,
} from 'types';

export type TVisibleForm = 'mainForm' | 'translations';
export type TSelectedItem = Nullable<string>;
export type TTypeOfModalWindow =
	| null
	| 'success'
	| 'error'
	| 'fileSizeExceeded'
	| 'fileUploadError'
	| 'invalidFileFormat'
	| 'defaultTranslationIsEmpty';

export interface ICreateSubcategoryModalState {
	visibleForm: TVisibleForm;
	fileId: TFileId;
	IDCustomer: TSelectedItem;
	IDRestaurant: TSelectedItem;
	nameOfSubCategory: string;
	IDSelectedCategory: TSelectedItem;
	isHiddenSubCategory: boolean;
	isAvailableForRepetition: boolean;
	defaultCustomerLanguage: Nullable<IDefaultLanguage>;
	selectedTranslationTab: Nullable<TLanguageIDs>;
	translations: IMenuTranslation[];
	typeOfModalWindow: TTypeOfModalWindow;
	errorResponseData: IServerError<ICreateSubCategoryValidationError> | null;
}

export const createSubcategoryModalInitialState: ICreateSubcategoryModalState = {
	visibleForm: 'mainForm',
	fileId: null,
	IDCustomer: null,
	IDRestaurant: null,
	nameOfSubCategory: '',
	IDSelectedCategory: null,
	isHiddenSubCategory: false,
	isAvailableForRepetition: false,
	defaultCustomerLanguage: null,
	selectedTranslationTab: null,
	translations: [],
	typeOfModalWindow: null,
	errorResponseData: null,
};

export interface ICreateSubcategoryModalContext extends ICreateSubcategoryModalState {
	changeVisibleForm(value: TVisibleForm): void;
	setFileId(fileId: TFileId): void;
	changeNameOfSubCategory(value: string): void;
	setIDSelectedCategory(value: TSelectedItem): void;
	changeSubCategoryVisibilityStatus(value: boolean): void;
	changeAvailableForRepetition(value: boolean): void;
	setTranslationTab(value: Nullable<TLanguageIDs>): void;
	setFetchedTranslations(value: TLanguageIDs[], defaultCustomerLanguage: Nullable<IDefaultLanguage>): void;
	changeNameTranslation(languageId: TLanguageIDs, value: string): void;
	changeTypeOfModalWindow(value: TTypeOfModalWindow): void;
	showErrorModalWithInfo(value: IServerError<ICreateSubCategoryValidationError> | null): void;
}

export const CreateSubcategoryModalContext = createContext<ICreateSubcategoryModalContext>({
	changeVisibleForm: () => undefined,
	setFileId: () => undefined,
	changeNameOfSubCategory: () => undefined,
	setIDSelectedCategory: () => undefined,
	changeSubCategoryVisibilityStatus: () => undefined,
	changeAvailableForRepetition: () => undefined,
	setTranslationTab: () => undefined,
	setFetchedTranslations: () => undefined,
	changeNameTranslation: () => undefined,
	changeTypeOfModalWindow: () => undefined,
	showErrorModalWithInfo: () => undefined,
	...createSubcategoryModalInitialState,
});
